// PrivacyPolicy.jsx
import React, { useEffect, useState } from 'react';
import { Modal, Form, Input, Switch, Select } from 'antd';
import { BreathAPIs } from '../../APIs/BreathAPIs';
import { toast } from 'react-toastify';
import { ButtonCustom } from '../../BootstrapComponents/ButtonCustom';
import styles from './styles.module.css';

const EditBooking = ({ modalVisible, closeModal, selBooking, submitFeedback }) => {
    const handleCancel = () => {
        closeModal();
    };

    const [isSubmitting, setIsSubmitting] = useState(false);

    // Add a state to store booking data
    const [bookingData, setBookingData] = useState({
        bookingEnded: false,
        isSessionActive: false,
        bookingStatus: 'Upcoming',
        RemoteTnxStatus: "Accepted",
        totalCost: 0,
        unUtilizedFee: 0,
        IdleDuration: 0
    });

    useEffect(() => {
        if (selBooking) {
            setBookingData(prevBookingData => ({
                ...prevBookingData,
                _id: selBooking?._id,
                bookingEnded: selBooking?.bookingEnded,
                isSessionActive: selBooking?.isSessionActive,
                bookingStatus: selBooking?.bookingStatus,
                totalCost: selBooking?.totalCost,
                unUtilizedFee: selBooking?.unUtilizedFee,
                IdleDuration: selBooking?.IdleDuration,
                RemoteTnxStatus: selBooking?.remoteTransactionStatus[selBooking?.remoteTransactionStatus.length - 1]
            }));

            console.log(bookingData);
        }
    }, [selBooking]);

    const formatDate = (dateString) => {
        const dateToConvert = new Date(dateString);
        const options = {
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            hour12: true
        };
        let updatedFormat = dateToConvert.toLocaleTimeString(undefined, options);
        return updatedFormat;
    }
    

    const { Option } = Select;
    const [form] = Form.useForm();

    const userSubmit = async () => {
        try {
            setIsSubmitting(true);
            const bookingUpdateCreatedAt = new Date()
            let updatedBookingData = {
                ...bookingData
            }
            let updatedRemoteTransactionStatus = [...(selBooking.remoteTransactionStatus || [])];
            (bookingData.RemoteTnxStatus !== updatedRemoteTransactionStatus[updatedRemoteTransactionStatus.length - 1]) && updatedRemoteTransactionStatus.push(bookingData.RemoteTnxStatus);
            updatedBookingData.remoteTransactionStatus = updatedRemoteTransactionStatus;
            setBookingData(updatedBookingData);
            const res = await BreathAPIs.updateBookingAdmin(updatedBookingData,bookingUpdateCreatedAt);
            form.resetFields();
            submitFeedback(res?.data?.message);
            setIsSubmitting(false);
            closeModal();
        } catch (error) {
            toast.error('Error updating booking.');
            setIsSubmitting(false);
        }
    };

    return (
        <Modal
            title="Edit Booking"
            open={modalVisible}
            onCancel={handleCancel}
            footer={null}
            width={window.innerWidth <= 768 ? '100%' : '50%'}
        >
            <div className={styles['edit-booking-top']}>
                <div>ID : <b>{selBooking?._id}</b></div>
                <div>Time : <b>{formatDate(selBooking?.startTime)} - {formatDate(selBooking?.endTime)}</b></div>
                <div>User : <b>{selBooking?.user?.firstName + ' ' + selBooking?.user?.lastName}</b></div>
                <div>Email : <b>{selBooking?.user?.email }</b></div>
                <div>Charger : <b>{selBooking?.charger?.chargerTag } ({selBooking?.charger?._id })</b> </div>
                <div>Sessions: <b>{selBooking?.sessions?.length}</b></div>
            </div>
            <Form form={form} onFinish={userSubmit} layout={'vertical'} initialValues={bookingData}>
                <Form.Item label="Total Cost (Idle fee isn't included)">
                    <Input type='number' value={bookingData.totalCost} onChange={(e) => setBookingData(prev => ({ ...prev, totalCost: e.target.value }))} />
                </Form.Item>

                <Form.Item label="Booking Ended">
                    <Switch checked={bookingData.bookingEnded} onChange={checked => setBookingData(prev => ({ ...prev, bookingEnded: checked }))} />
                </Form.Item>

                <Form.Item label="Is Session Active">
                    <Switch checked={bookingData.isSessionActive} onChange={checked => setBookingData(prev => ({ ...prev, isSessionActive: checked }))} />
                </Form.Item>

                <Form.Item label="Booking Status">
                    <Select value={bookingData.bookingStatus} onChange={value => setBookingData(prev => ({ ...prev, bookingStatus: value }))}>
                        <Option value="Upcoming">Upcoming</Option>
                        <Option value="Inprogress">Inprogress</Option>
                        <Option value="Idle">Idle</Option>
                        <Option value="Completed">Completed</Option>
                        <Option value="TimeOut">TimeOut</Option>
                        <Option value="Cancelled">Cancelled</Option>
                        <Option value="rfid-authenticated">rfid-authenticated</Option>
                    </Select>
                </Form.Item>

                <Form.Item label="Remote Transaction Status">
                    <Select value={bookingData.RemoteTnxStatus} onChange={value => setBookingData(prev => ({ ...prev, RemoteTnxStatus: value }))}>
                        <Option value="Accepted">Accepted</Option>
                        <Option value="Loading">Loading</Option>
                        <Option value="Accepted-Disable">Accepted-Disable</Option>
                        <Option value="Rejected">Rejected</Option>
                    </Select>
                </Form.Item>

                <Form.Item label="Unutilized Time Fee">
                    <Input type='number' value={bookingData.unUtilizedFee} onChange={e => setBookingData(prev => ({ ...prev, unUtilizedFee: e.target.value }))} />
                </Form.Item>

                <Form.Item label="Idle Duration">
                    <Input type='number' value={bookingData.IdleDuration} onChange={e => setBookingData(prev => ({ ...prev, IdleDuration: e.target.value }))} />
                </Form.Item>

                <div className="col-md-12">
                    <Form.Item style={{ textAlign: 'right' }}>
                        <ButtonCustom isLoading={isSubmitting} text={isSubmitting ? 'Updating...' : 'Update Booking'} type="submit" />
                    </Form.Item>
                </div>
            </Form>
        </Modal>
    );
};

export default EditBooking;
